var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"common-tag-list"},_vm._l((_vm.badgeList),function(tag,index){return _c('span',{key:index,class:_setup.className(tag, index)},[_vm._v("\n    "+_vm._s(_setup.label(tag, index))+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }